var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDealflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.85742 4.70354C7.85744 3.91233 9.43985 2.59366 11.286 3.12113C11.0223 4.17606 8.91237 5.23101 7.85742 4.70354Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.527473
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4762 7.24133C4.73616 6.96141 4.06256 5.01482 5.20902 3.47466C6.10243 4.09454 6.34275 6.4412 5.4762 7.24133Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.527473
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9332 10.5087C3.14305 10.5495 1.74439 9.03736 2.17578 7.16643C3.24293 7.37532 4.40546 9.42789 3.9332 10.5087Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.527473
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.18985 14.3366C3.50466 14.7322 1.5714 14.0213 1.105 12.1588C2.15045 11.8597 4.11909 13.1593 4.18985 14.3366Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.527473
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41072 17.1938C6.05258 17.8994 4.04468 18.359 2.63722 17.053C3.34989 16.2317 5.70877 16.246 6.41072 17.1938Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.527473
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04793 19.8306C8.68979 20.5361 6.68188 20.9957 5.27443 19.6897C5.9871 18.8684 8.34598 18.8827 9.04793 19.8306Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.527473
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.26194 7.61295C5.50088 6.87425 7.10278 6.03241 8.34782 6.97908C7.82864 7.89912 5.90514 8.36496 5.26194 7.61295Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.527473
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33244 11.1251C4.25459 10.3526 5.38353 8.93832 6.90394 9.30527C6.79797 10.3564 5.2235 11.5555 4.33244 11.1251Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.527473
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33254 13.7613C4.25431 12.985 5.34154 11.5684 6.81431 11.9428C6.7157 12.9983 5.19648 14.197 4.33254 13.7613Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.527473
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85807 17.3525C5.65345 16.9352 6.1949 15.807 7.3609 15.5802C7.48665 16.2087 6.58283 17.3421 5.85807 17.3525Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.527473
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74267 19.4412C8.1916 19.1869 7.65547 17.9346 8.46892 17.1378C9.13996 17.615 9.36494 19.0586 8.74267 19.4412Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.527473
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0219 20.2639C9.1056 19.9193 7.36775 18.8862 6.11369 17.3459C4.85964 15.8056 4.16961 13.8568 4.16482 11.8418C4.16003 9.82673 4.8408 7.87439 6.08751 6.32775C7.33423 4.7811 9.06715 3.73909 10.9818 3.38477",
    stroke: "white",
    strokeWidth: 0.527473,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1426 4.70354C18.1426 3.91233 16.5602 2.59366 14.714 3.12113C14.9777 4.17606 17.0876 5.23101 18.1426 4.70354Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.527473
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5238 7.24133C21.2638 6.96141 21.9374 5.01482 20.791 3.47466C19.8976 4.09454 19.6572 6.4412 20.5238 7.24133Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.527473
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0668 10.5087C22.857 10.5495 24.2556 9.03736 23.8242 7.16643C22.7571 7.37532 21.5945 9.42789 22.0668 10.5087Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.527473
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8101 14.3366C22.4953 14.7322 24.4286 14.0213 24.895 12.1588C23.8496 11.8597 21.8809 13.1593 21.8101 14.3366Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.527473
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5893 17.1938C19.9474 17.8994 21.9553 18.359 23.3628 17.053C22.6501 16.2317 20.2912 16.246 19.5893 17.1938Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.527473
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9521 19.8306C17.3102 20.5361 19.3181 20.9957 20.7256 19.6897C20.0129 18.8684 17.654 18.8827 16.9521 19.8306Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.527473
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7381 7.61295C20.4991 6.87425 18.8972 6.03241 17.6522 6.97908C18.1714 7.89912 20.0949 8.36496 20.7381 7.61295Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.527473
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6676 11.1251C21.7454 10.3526 20.6165 8.93832 19.0961 9.30527C19.202 10.3564 20.7765 11.5555 21.6676 11.1251Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.527473
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6675 13.7613C21.7457 12.985 20.6585 11.5684 19.1857 11.9428C19.2843 12.9983 20.8035 14.197 21.6675 13.7613Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.527473
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1419 17.3525C20.3466 16.9352 19.8051 15.807 18.6391 15.5802C18.5133 16.2087 19.4172 17.3421 20.1419 17.3525Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.527473
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2573 19.4412C17.8084 19.1869 18.3445 17.9346 17.5311 17.1378C16.86 17.615 16.6351 19.0586 17.2573 19.4412Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.527473
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9781 20.2639C16.8944 19.9193 18.6323 18.8862 19.8863 17.3459C21.1404 15.8056 21.8304 13.8568 21.8352 11.8418C21.84 9.82673 21.1592 7.87439 19.9125 6.32775C18.6658 4.7811 16.9328 3.73909 15.0182 3.38477",
    stroke: "white",
    strokeWidth: 0.527473,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealflow);
export default __webpack_public_path__ + "static/media/dealflow.7e7b4a73a49df68b1e7a47faa4f027c3.svg";
export { ForwardRef as ReactComponent };